import Vue from "vue";
import {
  Icon,
  Tab,
  Tabs,
  List,
  Cell,
  Button,
  Popup,
  Field,
  Dialog,
  Toast,
  Swipe,
  SwipeItem,
  Area,
  NavBar,
  CellGroup,
  Image,
  Sticky,
  Card,
  Lazyload,
  SubmitBar,
  RadioGroup,
  Radio,
  ActionSheet,
  Checkbox,
  CouponCell,
  CouponList,
  AddressList,
  AddressEdit,
  Loading,
  Search,
  empty
} from "vant";

Toast.setDefaultOptions({ duration: 2000 });

Vue.use(empty);
Vue.use(Search);
Vue.use(Loading);
Vue.use(AddressList);
Vue.use(AddressEdit);
Vue.use(CouponCell);
Vue.use(CouponList);
Vue.use(Checkbox);
Vue.use(ActionSheet);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Icon);
Vue.use(SubmitBar);
Vue.use(Card);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Area);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Image);
Vue.use(Sticky);
Vue.use(Lazyload);
